import { CATEGORIES, PLATFORMS, CATEGORY_PLATFORMS, DEFAULT_SUBCATEGORIES, PLATFORM_MODELS, } from '../constants/inventory.js';
export const retroComputersVaultType = {
    id: 'retro_computers',
    label: 'Retro Computers',
    tagline: 'Preserve the machines that started it all',
    icon: 'Monitor',
    platformLabel: 'Platform',
    categories: CATEGORIES,
    brands: PLATFORMS,
    brandModels: PLATFORM_MODELS,
    categoryBrands: CATEGORY_PLATFORMS,
    subcategories: DEFAULT_SUBCATEGORIES,
    conditions: ['mint', 'excellent', 'good', 'fair', 'poor', 'parts'],
    specializedFields: [
        { key: 'cpu', label: 'CPU', type: 'text', placeholder: 'e.g. MOS 6510' },
        { key: 'memory', label: 'Memory', type: 'text', placeholder: 'e.g. 64KB' },
    ],
    specializedFeatures: {
        capacitor_maps: true,
        retrobright: true,
        video_system: true,
        item_links: true,
    },
    aiSystemPrompt: `You are an expert in retro computing and vintage computer hardware. Analyze the provided image and identify the device. Provide details including: the manufacturer/platform, model name, approximate year of manufacture, category (Computer, Console, Peripheral, etc.), condition assessment, and any notable features or historical significance. If you can identify specific chips, ports, or modifications, mention those as well.`,
    maintenanceAlertTypes: [
        'battery_removal',
        'cap_replacement',
        'clock_battery',
        'fan_replacement',
        'psu_recap',
        'floppy_belt',
        'custom',
    ],
    fileTypes: [
        'manual_pdf', 'disk_d64', 'disk_tap', 'disk_adf', 'disk_dsk',
        'rom', 'firmware', 'schematic', 'other',
    ],
    defaultThemes: ['green_phosphor', 'amber_phosphor', 'commodore', 'atari', 'spectrum', 'amstrad', 'amiga'],
};
//# sourceMappingURL=retroComputers.js.map